<template lang="pug">
  .component-client-profile
    .action-bar
      .title
        h2 Client Profile
      .action
        span(data-toggle="edit-main-driver") Edit main driver
    .client-drivers.tabs-inner-content
      #edit-main-driver.is-hidden(data-toggler="is-hidden", v-f="")
        selectize-driver(
        v-if="options",
        :clientDrivers="options",
        @optionSelected="driverSelected"
        )
        button.button.success(v-on:click="updateMainDriver") Update Main driver
    .tabs-inner-content
      .client-profile
        .row
          .columns
            client(:type="'personal-data'", :item="client")
            client(:type="'billing'", :item="client")
          .columns
            client(:type="'contacts'", :item="client")
            client(:type="'main-driver'", :item="client")
            .columns.driver-licenses()
              driver-licence(
                v-for="license in driverLicenses",
                :type="'license-card-accordion'",
                :item="license",
                )
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice"
  import Client from 'components/backoffice/Client'
  import DriverLicence from "components/backoffice/DriverLicence"
  import SelectizeDriver from "../../structure/ui/lists/selectize/SelectizeDriver"

  export default {
    name: "ClientProfile",
    components: {
      DriverLicence,
      Client,
      SelectizeDriver,
    },
    data() {
      return {
        client: null,
        driverLicenses: [],
        driver_id: null,
        options: null,
        diffs: null,
        client_status : null,
        component: require('components/backoffice/Driver')
      }
    },
    created() {
      KeplerBackofficeSdk.clients.select(this.$route.params.id).get((data) => {
        this.client = data
        this.loadDriverLicenses(this.client.main_driver.id)
      })
    },
    methods: {
      loadDriverLicenses(id) {
        KeplerBackofficeSdk.drivers.select(id).getLicences((data) => {
          this.driverLicenses = data
        })
      },
      driverSelected(driver) {
        this.driver_id = driver.id
      },
      updateMainDriver() {
        KeplerBackofficeSdk.clients.select(this.$route.params.id).setMainDriver(this.driver_id, () => {
          MaggieHelper.notification('edit-esit', 'Main driver updated')
        })
      },
      driverLoader(callback, page, resultsPerPage) {
        KeplerBackofficeSdk.clients.list(page, resultsPerPage, {id: this.$route.params.id})
          .drivers((data) => {
            this.options = data.items
          })
      },
      getDifference(a, b) {
        return Object.fromEntries(Object.entries(b).filter(([key, val]) => key in a && a[key] !== val));
      }
    },
    mounted: function () {
      this.driverLoader()
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">
.border-class
  border-color: red
  color: red
</style>



// WEBPACK FOOTER //
// ClientProfile.vue?6de49e22